export default __webpack_public_path__ + "static/char-thumb-33-76f2de4c25ee85785e975d33219e0701.webp";